import { render, staticRenderFns } from "./GaleriFotoList.vue?vue&type=template&id=0ff18f8d"
import script from "./GaleriFotoList.vue?vue&type=script&lang=js"
export * from "./GaleriFotoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports